module.exports = __webpack_public_path__ + "static/terra-mattress-4-99a1a3eef4a811c4c8249129a1cba9ae.png";